import mod from "-!./CreateBusinessBook.js?vue&type=script&lang=js&"; export default mod; export * from "-!./CreateBusinessBook.js?vue&type=script&lang=js&"